import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/main.vue'),
    meta: { keepAlive: false }
  },
    {
    path: '/sort/:id?',
    name: 'sort',
    component: () => import('../views/sort.vue'),
  },
  {
    path: '/car',
    name: 'car',
    component: () => import('../views/car.vue'),
  },
    {
    path: '/user',
    name: 'user',
    component: () => import('../views/user.vue'),
  },
    {
    path: '/my',
    name: 'my',
    component: () => import('../views/my.vue'),
  },
    {
    path: '/goodsDetail/:id',
    name: 'goodsDetail',
    component: () => import('../views/goodsDetail.vue'),
  },{
    path: '/order',
    name: 'order',
    component: () => import('../views/order.vue'),
  },{
    path: '/orderXq/:id',
    name: 'orderXq',
    component: () => import('../views/orderXq.vue'),
  },{
    path: '/sureOrder/:id',
    name: 'sureOrder',
    component: () => import('../views/sureOrder.vue'),
  },{
    path: '/saleApply/:id',
    name: 'saleApply',
    component: () => import('../views/saleApply.vue'),
  },{
    path: '/saleAfter/:id',
    name: 'saleAfter',
    component: () => import('../views/saleAfter.vue'),
  },{
    path: '/addAddress/:address_id',
    name: 'addAddress',
    component: () => import('../views/addAddress.vue'),
  },{
    path: '/myAddress/:type?',
    name: 'myAddress',
    component: () => import('../views/myAddress.vue'),
  },{
    path: '/setUserName/:name',
    name: 'setUserName',
    component: () => import('../views/setUserName.vue'),
  },{
    path: '/myCollect',
    name: 'myCollect',
    component: () => import('../views/myCollect.vue'),
  },{
    path: '/searchResult',
    name: 'searchResult',
    component: () => import('../views/searchResult.vue'),
  },{
    path: '/myDown',
    name: 'myDown',
    component: () => import('../views/myDown.vue'),
  },
  {
    path: '/tixian',
    name: 'tixian',
    component: () => import('../views/tixian.vue'),
  },{
    path: '/tixianRecord',
    name: 'tixianRecord',
    component: () => import('../views/tixianRecord.vue'),
  },
  {
    path: '/fenxiao',
    name: 'fenxiao',
    component: () => import('../views/fenxiao.vue'),
  },{
    path: '/sureOrderCar/:ids',
    name: 'sureOrderCar',
    component: () => import('../views/sureOrderCar.vue'),
  },{
    path: '/fenOrder',
    name: 'fenOrder',
    component: () => import('../views/fenOrder.vue'),
  },{
    path: '/notice',
    name: 'notice',
    component: () => import('../views/notice.vue'),
  },{
    path: '/noticeDetail/:id',
    name: 'noticeDetail',
    component: () => import('../views/noticeDetail.vue'),
  },{
    path: '/bannerDetail/:id',
    name: 'bannerDetail',
    component: () => import('../views/bannerDetail.vue'),
  },{
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('../views/wxLogin.vue'),
  },{
    path: '/changePhone/:phone',
    name: 'changePhone',
    component: () => import('../views/changePhone.vue'),
  },{
    path: '/notFound/:msg',
    name: 'notFound',
    component: () => import('../views/notFound.vue'),
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加路由守卫，验证登录状态
router.beforeEach((to, from, next) => {
  //  if (to.meta.title) {
  //   document.title = to.meta.title  // 核心代码
  // }
  next()
})

router.onError((err) => {
  if (err.name === 'NavigationCancelledError' || err.name === 'NavigationDuplicatedError') {
    return
  }
  console.error('路由错误:', err)
})

export default router
